import { cx } from '../../utils';
import styles from './CdLogo.module.scss';

export interface CdLogoProps {
  /** `onDark` for the navy nav/footer, `onLight` for white headers. */
  tone?: 'onDark' | 'onLight';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/** PermiOne wordmark. TODO: swap for the exported SVG from Figma once available. */
export const CdLogo = ({ tone = 'onLight', size = 'md', className }: CdLogoProps) => {
  return (
    <span className={cx(styles.logo, styles[tone], styles[size], className)}>
      <span className={styles.permi}>Permi</span>
      <span className={styles.one}>One</span>
    </span>
  );
};
